import service from './service';

export const getInvoiceData = async (companyId, userId) => {
  try {
    const response = await service.getPublic(`/invoice/company/${companyId}/user/${userId}`);

    if (response.status === 200) {
      const data = response.data;

      return data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
